export default "__VITE_ASSET__6p63MqM1__"